<template>
  <div>
    <footer class="footer" id="footer">
      <div class="container">
        <hr />
        <div class="row">
          <div class="col-md-6">
            <ul class="list-inline">
              <li>
                <a href="http://www.ignitionnbs.co.uk" target="_blank">Ignition NBS</a>
              </li>
              <!-- <li>
                <router-link to="/info/disclaimer/">Disclaimer</router-link>
              </li>
              <li>
                <router-link to="/info/terms/">Terms &amp; Conditions</router-link>
              </li> -->
              
            </ul>
          </div>
          <div class="col-md-6">
            Copyright &copy; Ignition NBS 2014 - {{ new Date().getFullYear() }}
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <strong>Support:</strong>
            <br />
            <span class="h2">0161 831 7199</span>
            <br /><br />
          </div>
          <div class="col-md-6">
            <strong>Ignition New Business Solutions Limited.</strong>
            <br />
            Trading address: 5th Floor, 82 King Street, Manchester M2 4WQ <br />
            Registered address: 20 Gracechurch Street, London EC3V 0BG
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { AppConfig } from '@/config/config';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['isAuthenticated']),
  },
};
</script>

<style scoped>
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  /* Set the fixed height of the footer here */
  min-height: 130px;
  background-color: #333;
  color: #666;
  font-size: 0.833rem;
  z-index: -10;
}

.footer .h2 {
  font-size: 1.44rem;
  color: #fff;
}

.footer hr {
  border-top: 1px solid #5c5c5c;
  margin-top: 10px;
}

.footer a {
  color: #ccc;
  text-transform: uppercase;
}

#footer a:hover {
  color: #999;
  text-decoration: none;
}
</style>
